import { SafeReportMetadataResponse } from "../Conversion";

export type RowData = SafeReportMetadataResponse | { __loading: true };
export type GroupedRowData = RowData & { __group?: string };
export type LoadedReportRow = SafeReportMetadataResponse & { __group?: string };

export const isLoadingState = (data: RowData): data is { __loading: true } =>
  "__loading" in data;
